import { render } from "./Home.vue?vue&type=template&id=58b6e60c"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=58b6e60c&lang=scss"
script.render = render

export default script